import { api } from '@/lib/api'

import type {
	AzureSignupDetails,
	AzureSignupUserData,
	User,
	UserRequest,
} from './types'

/**
 * Fetch the current user's data from API
 */
export const fetchMe = async (signal?: AbortSignal) => {
	// We fetch the user data
	const { data } = await api.get<UserRequest>('/me', {
		signal,
	})

	return data
}

/**
 * Update the current user's data in API
 * @param user_data - Partial user data
 */
export const updateMe = async (user_data: Partial<User>) => {
	const { data } = await api.patch<UserRequest>(`/me`, user_data)

	return data
}

/**
 * Delete current user's data from API (449 confirmation handled automatically by API client)
 */
export const deleteMe = async () => {
	const { data } = await api.delete<string>(`/me`)

	return data
}

/**
 * Get the Azure subscription details
 * @param token - The token to get the Azure subscription details for
 * @returns The Azure subscription details
 */
export const getAzureSignupDetails = async (
	token: string,
	signal?: AbortSignal,
) => {
	const { data } = await api.get<AzureSignupDetails>(
		`/external_providers/azure_marketplace/signup_details?token=${token}`,
		{
			signal,
		},
	)

	return data
}

/**
 * Confirm the Azure signup
 * @param token - The token to confirm the Azure signup for
 * @param userData - The user data to confirm the Azure signup for
 * @returns The confirmed Azure signup
 */
export const activateAzureAccount = async (
	token: string,
	userData: AzureSignupUserData,
) => {
	const { data } = await api.post<string>(
		`/external_providers/azure_marketplace/activate?token=${token}`,
		{
			body: userData,
		},
	)

	return data
}
